'use client';
import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa6';

const ShopSidebarDiscount = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const handleClick = () => {
    setIsCollapsed((prev) => !prev);
  };
  return (
    <div
      className={`sidebar-filter sidebar-filter--brand sidebar-filter--collapsible  ${isCollapsed ? 'is-collapsed' : ''}`}
    >
      <div className="sidebar-filter__header">
        <h3 className="sidebar-filter__title">Discount</h3>
        <button
          onClick={handleClick}
          className="sidebar-filter__toggle btn btn-link p-0"
        >
          <FaChevronDown />
        </button>
      </div>
      <div id="brand-filter-content2" className="sidebar-filter__content">
        <ul className="sidebar-filter__list list-unstyled">
          <li className="sidebar-filter__item">
            <div className="form-check">
              <div className="check-group flex-grow-1">
                <input
                  className="form-check-input"
                  type="checkbox"
                  defaultChecked
                  id="d1-check"
                />
                <label className="form-check-label d-block" htmlFor="d1-check">
                  Up to 5%
                </label>
              </div>
              <span className="sidebar-filter__count">(34)</span>
            </div>
          </li>
          <li className="sidebar-filter__item">
            <div className="form-check">
              <div className="check-group flex-grow-1">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="d2-check"
                />
                <label className="form-check-label d-block" htmlFor="d3-check">
                  05% - 20%
                </label>
              </div>
              <span className="sidebar-filter__count">(24)</span>
            </div>
          </li>
          <li className="sidebar-filter__item">
            <div className="form-check">
              <div className="check-group flex-grow-1">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="d3-check"
                />
                <label className="form-check-label d-block" htmlFor="d3-check">
                  20% - 30%
                </label>
              </div>
              <span className="sidebar-filter__count">(8)</span>
            </div>
          </li>
          <li className="sidebar-filter__item">
            <div className="form-check">
              <div className="check-group flex-grow-1">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="d4-check"
                />
                <label className="form-check-label d-block" htmlFor="d4-check">
                  30% - 50%
                </label>
              </div>
              <span className="sidebar-filter__count">(05)</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ShopSidebarDiscount;
